import { Observable, Subscription, timer } from "rxjs";

export class SmTimer {

    private t: Observable<number>;
    private subscription: Subscription;
    private running = false;

    constructor(public name: string, public initial: number, public period: number, private onTimer: () => void | Promise<void>, private skipIfRunning: boolean = false) {
        this.t = timer(initial, period);
        this.subscription = this.t.subscribe(async _ => this.onTimerInternal());
    }

    destroy(): void {
        this.subscription.unsubscribe();
    }

    async onTimerInternal(): Promise<void> {
        if (!this.skipIfRunning) {
            await this.onTimer();
            return;
        }
        if (this.skipIfRunning && this.running) {
            console.log("Der Timer-Aufruf '" + this.name + "' wird übersprungen, da er bereits läuft");
            return;
        }
        this.running = true;
        try {
            await this.onTimer();
        }
        finally {
            this.running = false;
        }
    }
}
